import React, {useState} from "react";
import {
    Button,
    Column,
    Columns,
    Control,
    Field,
    Input,
    Modal,
    Section,
    Table,
    Title,
} from "@allxsmith/bestax-bulma";
import StageChangeRow from "./StageChangeRow";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";


export default function StateChangeModal({selectedWork, multi=false, setMulti, getCurrentState, setSelected, dataFresh, filteredWork, setFilteredWork, currentFilter, view, open, setOpen, endpoint, onWorkSave, onStageChange, workTypeObjects, workTypes, nominalCodes, codeObjects, trackingOptions, trackingOptionObjects}){
    let currentState;
    if(multi){
        currentState = getCurrentState(filteredWork.results[0]);
    }
    else{
        currentState = getCurrentState(selectedWork);
    }

    const onAmountPaidSave = (work, customerAmountPaid) => {
      // get job
      const url = endpoint + "jobs/" + work.job;
      const conf = {
        method: "get",
        url
      };

      return axios(conf).then(resp => {
          let jobData = resp.data;
          if(work.chargeable){
              jobData.customer2_paid_amount= customerAmountPaid
          }
          else if(!work.chargeable){
              jobData.customer1_paid_amount= customerAmountPaid
          }
          const putConf = {
              url: url,
              method: "put",
              data: jobData
          }
          axios(putConf)
      })
    }

    const getColor = () => {
        if(view === "po"){
            if(selectedWork && filteredWork){
                if(selectedWork.no_free_of_charge_count === filteredWork.results.length){
                    return "table-highlight-green";
                }
            }
        }
        else if(view === "invoice") {
            if (selectedWork && filteredWork) {
                if (selectedWork.work_count === filteredWork.results.length) {
                    return "table-highlight-green";
                }
            }
        }
        return "table-highlight-red";
    }
    const getTotalCustomerCharge = () => {
        let total = 0;
        filteredWork.results.forEach(item => {
            total = total + parseFloat(item.customer_labour_cost);
            item.parts.forEach(part => {
                total = total + parseFloat(part.customer_cost)
            })
        })
        return (Math.round((total + Number.EPSILON) * 100) / 100)
    }
    const getTotalChargeToUs = () => {
        let total = 0;
        filteredWork.results.forEach(item => {
            total = total + parseFloat(item.labour_cost);
            item.parts.forEach(part => {
                total = total + parseFloat(part.cost)
            })
        })
        return (Math.round((total + Number.EPSILON) * 100) / 100)
    }

    const getCustomer = () => {
        if(selectedWork.chargeable){
            //Customer 2
            return selectedWork.customer2
        }
        else if(!selectedWork.chargeable){
            //Customer 1
            return selectedWork.customer
        }
    }

    const onPartSave = (partIndex, work) => {
      const conf = {
          method: "put",
          url: endpoint+"parts/update/"+work.parts[partIndex].id,
          data: work.parts[partIndex]
      }
      return axios(conf).catch(err => {
          toast.error("There was an error", {position: "top-right"});
      })
    };

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            closeOnBlur
            active={open}
            onClose={() => {
                setFilteredWork({results: []});
                setSelected({})
                setMulti(false);
                setOpen(false);
            }}
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{ backgroundColor: "white" }}>
                    <Title>All related work</Title>
                    {!multi &&
                        <Columns isMultiline>
                            <Column>
                                <Field>
                                    <Control>
                                        <label className="label">Registration</label>
                                        <Input
                                            type={"text"}
                                            value={selectedWork ? selectedWork.vehicle_registration : ""}
                                            disabled={true}
                                        />
                                    </Control>
                                </Field>
                            </Column>
                            <Column>
                                <Field>
                                    <Control>
                                        <label className="label">Customer</label>
                                        <Input
                                            type={"text"}
                                            value={selectedWork ? getCustomer() : ""}
                                            disabled={true}
                                        />
                                    </Control>
                                </Field>
                            </Column>
                            <Column>
                                <Field>
                                    <Control>
                                        <label className="label">Workshop</label>
                                        <Input
                                            type={"text"}
                                            value={selectedWork ? selectedWork.workshop : ""}
                                            disabled={true}
                                        />
                                    </Control>
                                </Field>
                            </Column>
                            <Column>
                                <Field>
                                    <Control>
                                        <label className="label">{selectedWork ? (selectedWork.quote ? "Quote ID" : "Job ID") : ""}</label>
                                        <Input
                                            type={"number"}
                                            value={selectedWork ? (selectedWork.quote ? selectedWork.quote : selectedWork.job) : ""}
                                            disabled={true}
                                        />
                                    </Control>
                                </Field>
                            </Column>
                            <Column>
                                <Field>
                                    <Control>
                                        <label className="label">Total Work Items</label>
                                        <Input
                                            type={"number"}
                                            disabled={true}
                                            className={getColor()}
                                            value={ view === "invoice" ? selectedWork ? selectedWork.work_count : "" : selectedWork ? selectedWork.no_free_of_charge_count : ""}
                                        />
                                    </Control>
                                </Field>
                            </Column>
                            <Column>
                                <Field>
                                    <Control>
                                        <label className="label">Total Customer Charge (Inc Parts)</label>
                                        <Input
                                            type={"number"}
                                            value={getTotalCustomerCharge()}
                                            disabled={true}
                                        />
                                    </Control>
                                </Field>
                            </Column>
                            <Column>
                                <Field>
                                    <Control>
                                        <label className="label">Total Cost To Us (Inc Parts)</label>
                                        <Input
                                            type={"number"}
                                            value={getTotalChargeToUs()}
                                            disabled={true}
                                        />
                                    </Control>
                                </Field>
                            </Column>
                        </Columns>
                    }
                    <Columns isMultiline>
                        <Column>
                            <Table
                                isFullwidth
                            >
                                <thead>
                                    <tr>
                                        <th>Job ID</th>
                                        <th>Description</th>
                                        <th>Comments</th>
                                        <th>Labour Cost (£)</th>
                                        <th>Customer Labour Charge</th>
                                        <th>{view === 'po' ? 'Workshop Invoice Number' : 'Customer Invoice Number'}</th>
                                        <th>Nominal Code</th>
                                        <th>Tracking Category</th>
                                        {view === "invoice" && <th>Customer Paid</th>}
                                        {view === 'po' && <th>Work Type</th>}
                                        {view === 'po' && <th>Due Date</th>}
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {((filteredWork && filteredWork.results) ?? []).map((work, index) => (
                                        <StageChangeRow
                                            onWorkSave={onWorkSave}
                                            work={work}
                                            view={view}
                                            key={work.id}
                                            index={index}
                                            workTypeObjects={workTypeObjects}
                                            workTypes={workTypes}
                                            nominalCodes={nominalCodes}
                                            codeObjects={codeObjects}
                                            onPartSave={onPartSave}
                                            trackingOptionObjects={trackingOptionObjects}
                                            trackingOptions={trackingOptions}
                                            onAmountPaidSave={onAmountPaidSave}
                                        />
                                    ))}
                                </tbody>
                            </Table>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={onStageChange}
                                isFullWidth
                            >
                                {currentState === "ready_to_approve" ? "Approve" : view === "po" ? "Approve Payment" : "Ready to Invoice"}
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={() => {
                                    setFilteredWork({results: []});
                                    setMulti(false);
                                    setSelected({});
                                    setOpen(false);
                                }}
                                isFullWidth
                            >
                                Cancel
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );


}